import { Navigate } from "react-router";
import { useAuthV2 } from "@cliently/auth-client";
import { LoginPageV2 } from "./pages/LoginPageV2";

/**
 * Variante auth-v2 du `RootRedirect` du portail : si signé, va sur /dashboard ;
 * sinon affiche la nouvelle page de login.
 */
export const RootRedirectV2 = () => {
  const { isSignedIn, isLoaded } = useAuthV2();

  if (!isLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="border-primary h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
      </div>
    );
  }
  if (isSignedIn) return <Navigate to="/dashboard" replace />;
  return <LoginPageV2 />;
};
